const enabled = true;

/**
 * Checks if the URL contains UTM parameters and returns them as an object.
 */
export function checkForExistingUtms() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get("utm_source");
  const utmCampaign = urlParams.get("utm_campaign");
  const utmMedium = urlParams.get("utm_medium");
  const utmTerm = urlParams.get("utm_term");
  const utmContent = urlParams.get("utm_content");
  const invite_id = urlParams.get("invite_id") ?? urlParams.get("invitationId");

  const result: Record<string, string> = {};

  if (utmSource) result.utm_source = utmSource;
  if (utmCampaign) result.utm_campaign = utmCampaign;
  if (utmMedium) result.utm_medium = utmMedium;
  if (utmTerm) result.utm_term = utmTerm;
  if (utmContent) result.utm_content = utmContent;
  if (invite_id) result.invite_id = invite_id;

  return result;
}

function getPagePath() {
  return window.location.pathname;
}

export function trackEvent(eventName: string, eventProperties = {}) {
  if (!enabled) {
    return;
  }

  const utm = checkForExistingUtms();

  if (utm) {
    setUserPropertiesOnce({
      first_utm_source: utm.utm_source,
      first_utm_campaign: utm.utm_campaign,
      first_utm_medium: utm.utm_medium,
      first_utm_term: utm.utm_term,
      first_utm_content: utm.utm_content,
    });

    const properties = {
      utm_source: utm.utm_source,
      utm_campaign: utm.utm_campaign,
      utm_medium: utm.utm_medium,
      utm_term: utm.utm_term,
      utm_content: utm.utm_content,
    };

    setUserProperties({ ...properties });
    eventProperties = { ...eventProperties, ...properties };
  }

  const pagePath = getPagePath();

  if (pagePath) {
    eventProperties = { ...eventProperties, page_path: pagePath };
  }

  const referrer = document.referrer;

  if (referrer) {
    eventProperties = { ...eventProperties, referrer: referrer };
  }

  console.info("amplitude :: trackEvent", eventName, eventProperties);

  setTimeout(() => {
    // @ts-expect-error
    window.EvangelistTracker?.trackEvent({
      name: eventName,
      options: eventProperties,
    });
  }, 2500);
}

/**
 *
 * Set user properties using Amplitude Identify. Replaces existing properties if exist
 * @param props
 * @returns
 */
export function setUserProperties(props: Record<string, unknown>) {
  console.info("amplitude :: setUserProperties", props);
  if (!enabled) {
    return;
  }

  setTimeout(() => {
    // @ts-expect-error
    window.EvangelistTracker?.setUserProperties(props);
  }, 2500);
}

/**
 *
 * Set user properties using Amplitude Identify. Does not override existing properties.
 * @param props
 * @returns
 */
export function setUserPropertiesOnce(props: Record<string, unknown>) {
  console.info("amplitude :: setUserPropertiesOnce", props);
  if (!enabled) {
    return;
  }

  setTimeout(() => {
    // @ts-expect-error
    window.EvangelistTracker?.setUserPropertiesOnce(props);
  }, 2500);
}

/**
 * Track user using Amplitude use amplitude addUserId method.
 * @param userId
 * @returns
 */
export function trackUser(userId: string | undefined) {
  console.info("amplitude :: trackUser", userId ? "user-ok" : "user-ko");
  if (!enabled) {
    return;
  }

  setTimeout(() => {
    // @ts-expect-error
    window.EvangelistTracker?.identify({
      userId: userId,
    });
  }, 2500);
}

/**
 * Adds tracking attributes to all anchor tags in the given HTML string.
 *
 * @param html - The HTML string to add tracking attributes to.
 * @returns The HTML string with tracking attributes added to all anchor tags.
 */
export function addTrackingAttributesToHtml(html: string) {
  // Create a temporary DOM element to parse the HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  // Find all anchor tags
  const links = tempDiv.querySelectorAll("a");

  // Add data attributes to each link
  links.forEach((link) => {
    // Add data attributes for analytics tracking
    link.setAttribute(
      "data-analytics-click-id",
      "external_link_campaign_description_clicked",
    );
    link.setAttribute("data-analytics-event-name", "user_site_left");
    link.setAttribute(
      "data-analytics-destination-domain",
      new URL(link.href).hostname,
    );
    link.setAttribute(
      "data-analytics-destination-path",
      new URL(link.href).pathname,
    );

    // Add target="_blank" to ensure links open in new tab
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });

  return tempDiv.innerHTML;
}
